<template>
  <section>
    <question v-if="display"></question>
    <errors v-if="isVisibleErrorsModal"></errors>
    <accountCreation v-if="isAccountCreationModalVisible"></accountCreation>
    <address-suggestion v-if="isSuggestedAddressModalVisible"></address-suggestion>
    <div class="content-wrapper content-wrapper-banner">
      <div class="content-heading">
        Personal information
        <small data-localize="dashboard.WELCOME"></small>
      </div>
      <div class="panel b text-white banner-width title-panel">
        <div class="panel-body bg-cover clearfix">
          <div class="media mt0">
            <div class="media-left">
              <a href="#">
                <img src="../assets/img/user/img-profile-default.svg" alt="Image" class="media-object img-thumbnail img-circle thumb45">
              </a>
            </div>
            <div class="media-body media-middle">
              <div class="clearfix">
                <div class="pull-left">
                  <p class="information-title">Personal Information</p>
                  <h3 class="media-heading m0">{{userProfile.firstName}} {{userProfile.lastName}}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper content-wrapper-container">
      <div class="row">
        <spinner v-if="isLoading"></spinner>
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-title">
              Basic information
            </div>

            <div class="line-separator"></div>

            <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">First name*</label>
                  <input type="text" name="FirstName" id="FirstName" v-model="userProfile.firstName" placeholder="First name" :class="{ 'form-control': true, 'form-control-error': errors.has('FirstName') }" v-validate="{required: true}"/>
                  <span v-if="errors.has('FirstName')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Last name*</label>
                  <input type="text" name="LastName" id="LastName" v-model="userProfile.lastName" placeholder="Last name" :class="{ 'form-control': true, 'form-control-error': errors.has('LastName') }" v-validate="{required: true}" />
                  <span v-if="errors.has('LastName')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Email*</label>
                  <input type="text" name="Email" id="Email" v-model="userProfile.email" placeholder="Email" :class="{ 'form-control': true, 'form-control-error': errors.has('Email') }" v-validate="{required: true}" />
                  <span v-if="errors.has('Email')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhoneNum">Primary phone number*</label>
                  <input id="primaryPhoneNum" name="primaryPhoneNum" v-model="userProfile.primaryPhoneNum" placeholder="Phone number" :class="{ 'form-control': true, 'form-control-error': errors.has('primaryPhoneNum') }" v-validate="'required'" v-mask="'(999) 999-9999'"
                  />
                  <span v-if="errors.has('primaryPhoneNum')" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="ssn">Secondary phone number</label>
                  <input v-model="userProfile.secondaryPhoneNum" class="form-control" type="text" id="spn" v-mask="'(999) 999-9999'" />
                </div>
              </div>
            </div>

            <addresses-form
              v-if="userProfile.residentialAddress.state"
              v-bind:firstTitle="'Residential Address'"
              v-bind:residentialAddress="userProfile.residentialAddress"
              v-bind:secondTitle="'Mailing Address'"
              v-bind:mailingAddress="userProfile.mailingAddress"
              v-bind:key="1"
              ref="addresses" >
            </addresses-form>


            <div class="row top-margin bottom-margin">
              <div class="col-md-2">
                <button type="submit"
                  v-bind:disabled="disableSubmitButton()"
                  class="btn btn-info btn-lg button-submit"
                  v-on:click="validateAndSubmitUser()">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapMutations,
    mapActions,
    mapState,
  } from 'vuex';
  import {
    SET_ERRORS_MODAL_INFO,
    SET_SUGGESTED_ADDRESS,
    SET_USER_BY_ADMIN,
    SET_USER,
    SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
    SET_SUGGESTED_ADDRESS_TYPE,
    SET_SUGGESTED_ADDRESS_YES_METHOD,
    SHOW_ERRORS_MODAL,
    SHOW_INFORMATION_MODAL,
    SHOW_QUESTION_MODAL,
    HIDE_QUESTION_MODAL,
    SHOW_ACCOUNT_CREATION_MODAL,
    SET_ACTIVE_ACCOUNT_ID,
  } from '@/store/mutation-types';


  import cloneDeep from 'lodash/cloneDeep';
  import moment from 'moment';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import addressSuggestion from '@/components/modals/AddressSuggestion';
  import errors from '@/components/modals/Errors';
  import information from '@/components/modals/Information';
  import spinner from '@/components/widgets/Spinner';
  import Question from '@/components/modals/Question';
  import accountCreation from '@/components/modals/AccountCreation';
  import RestrictedTwoInputs from '@/components/formControls/RestrictedTwoInputs';
  import addresses from '@/components/Addresses';
  import {
    formatDate,
    zipRegex,
  } from '@/util';
  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatDate,
    },
  };

  export default {
    name: 'EditUserProfileByAdvisor',
    async beforeMount() {
      this.isLoading = true;
      await this.loadUserDetail();
      this.isLoading = false;
    },
    mixins: [mix],
    data() {
      return {
        minimumAge: 18,
        isResidentDefaultAddress: false,
        userProfile: {
          accounts: [],
          residentialAddress: {
            streetAddress1: '',
          },
          mailingAddress: {
            streetAddress1: '',
          },
        },
        userName: '',
        userType: '',
        isLoading: true,
        isBirthFieldInvalid: false,
        dateBirthConfig: {
          format: 'MM/DD/YYYY',
        },
        dateBirthFormat: 'YYYY-MM-DD',
        previousSSN: '',
        creationSucceeded: false,
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('accountCreation', [
        'isSuggestedAddressModalVisible',
        'isAccountCreationModalVisible',
        'changeAddress',
        'suggestedAddressModalYesCall',
      ]),
      ...mapState('information', [
        'isInformationModalVisible',
      ]),
      ...mapState('question', [
        'display',
      ]),
      ...mapState('app', [
        'activeAccount',
        'activeAccountId',
        'user',
        'geoLocation',
      ]),
    },
    watch: {
      async suggestedAddressModalYesCall({ payload, suggestedAddress, addressType }) {
        if (!this.$refs.addresses.isMailingAddressDifferent) {
          this.userProfile.residentialAddress = suggestedAddress;
          this.userProfile.mailingAddress = suggestedAddress;
          this.$refs.addresses.setResidencialAddress(suggestedAddress);
          this.$refs.addresses.setMailingAddress(suggestedAddress);
        }
        if (['residential', 'organization'].includes(addressType)) {
          this.userProfile.residentialAddress = suggestedAddress;
          this.$refs.addresses.setResidencialAddress(suggestedAddress);
        } else if (addressType === 'mailing') {
          this.userProfile.mailingAddress = suggestedAddress;
          this.$refs.addresses.setMailingAddress(suggestedAddress);
        }
        await this.save(payload);
      },
    },
    methods: {
      ...mapActions('accountCreation', [
        'getUserDetail',
        'verifyResidentialAddress',
        'verifyMailingAddress',
        'updateUserProfile',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      ...mapMutations('information', {
        showInformationModal: SHOW_INFORMATION_MODAL,
      }),
      ...mapMutations('app', {
        setUser: SET_USER,
        setActiveAccountId: SET_ACTIVE_ACCOUNT_ID,
      }),
      ...mapMutations('accountCreation', {
        setSuggestedAddress: SET_SUGGESTED_ADDRESS,
        setUserByAdmin: SET_USER_BY_ADMIN,
        setSuggestedAddressType: SET_SUGGESTED_ADDRESS_TYPE,
        setSuggestedAddressModalVisible: SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
        setSuggestedAddressYesMethod: SET_SUGGESTED_ADDRESS_YES_METHOD,
        showAccountCreationModal: SHOW_ACCOUNT_CREATION_MODAL,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      residentialAddressUpdated($event) {
        this.userProfile.residentialAddress.streetAddress1 = $event.primary;
        this.userProfile.residentialAddress.streetAddress2 = $event.secondary;
      },
      mailingAddressUpdated($event) {
        this.userProfile.mailingAddress.streetAddress1 = $event.primary;
        this.userProfile.mailingAddress.streetAddress2 = $event.secondary;
      },
      addressAreEqual(adr1, adr2) {
        return adr1.city === adr2.city &&
          adr1.state === adr2.state &&
          adr1.streetAddress1 === adr2.streetAddress1 &&
          adr1.streetAddress2 === adr2.streetAddress2 &&
          adr1.zipCode === adr2.zipCode;
      },
      async loadUserDetail() {
        this.userType = 'Individual Investor';
        await this.getUserDetail(this.activeAccount.primaryInvestorId).then((data) => {
          this.userProfile = cloneDeep(data);

          this.userName = `${this.userProfile.firstName}  ${this.userProfile.lastName}`;
          this.userProfile.updateCount = data.updateCount ? data.updateCount : 0;
          this.userProfile.organizationName = data.accounts[0].organizationName;
          this.userProfile.CRDnumber = data.accounts[0].CRDnumber;
          this.userProfile.socialSecurityNum = `xxx-xx-${this.userProfile.socialSecurityNum}`;
          this.userProfile.dateOfBirth = moment.utc(`${this.userProfile.dateOfBirth} 12:00:00`);

          const { residentialAddress, mailingAddress } = this.userProfile;
          this.isResidentDefaultAddress = !this.addressAreEqual(residentialAddress, mailingAddress);

          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
        this.isLoading = false;
      },
      getPhoneDigits(phoneNum) {
        return phoneNum.replace(/[-() ]/g, '');
      },
      copyMailingAddress() {
        this.userProfile.mailingAddress = Object.assign({}, this.userProfile.residentialAddress);
      },
      isStateSelected(userProfile) {
        return userProfile.residentialAddress.state.length > 0;
      },
      validateUserProfile(userProfile) {
        const listUserErrors = [];

        const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
        if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
          listUserErrors.push('Enter a valid primary phone number.');
        }
        if (userProfile.secondaryPhoneNum.length > 0 &&
          !phoneRegex.test(userProfile.secondaryPhoneNum)) {
          listUserErrors.push('Enter a valid secondary phone number.');
        }
        if (!zipRegex.test(userProfile.residentialAddress.zipCode)) {
          listUserErrors.push('Provide a valid residential zip code.');
        }
        if (this.isResidentDefaultAddress &&
          !zipRegex.test(userProfile.mailingAddress.zipCode)) {
          listUserErrors.push('Provide a valid mailing zip code.');
        }
        if (!this.isStateSelected(userProfile)) {
          listUserErrors.push('Please select a state in order to save your profile.');
        }
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        if (userProfile.email) {
          if (!regex.test(userProfile.email)) {
            listUserErrors.push('Please, enter a valid email. ');
          }
        }
        return listUserErrors;
      },
      setDataWithoutMasks() {
        this.userProfile.primaryPhoneNum = this.getPhoneDigits(this.userProfile.primaryPhoneNum);
        this.userProfile.secondaryPhoneNum = this.getPhoneDigits(this.userProfile.secondaryPhoneNum);
        this.previousSSN = this.userProfile.socialSecurityNum;
      },
      isZipCodeInvalid(zipCode) {
        if (!zipCode) {
          return false;
        }
        return !zipRegex.test(zipCode);
      },
      truncateAddressIfNecessary(address) {
        const localAddress = { ...address };
        const hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
        const hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
        if (hasStreetAddress1 && hasStreetAddress2) {
          const totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
          if (totalAdressLength > 50) {
            const charsToCut = 50 - totalAdressLength;
            localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
            return localAddress;
          }
        }
        return address;
      },
      validateAndSubmitUser() {
        this.isLoading = true;
        this.setUserByAdmin(this.userProfile);
        const listUserErrors = this.validateUserProfile(this.userProfile);
        if (listUserErrors.length > 0) {
          this.showUserModalsError(listUserErrors);
          this.isLoading = false;
          return false;
        }
        if (!this.$refs.addresses.isMailingAddressDifferent) {
          this.copyMailingAddress();
        }
        this.setDataWithoutMasks();
        return this.showConfirmationModal();
      },
      async save(userData) {
        this.isLoading = true;
        try {
          const provideLoging = false;

          const options = provideLoging ? {
            provideLogin: this.provideInvestorLogin,
            enableMfa: this.enableMfa,
          } : {};

          const addressData = this.$refs.addresses.getData();

          // Advisors address -> organization
          const address = this.userProfile.userType === 'ADVISOR'
            ? { organizationAddress: addressData.residentialAddress }
            : { residentialAddress: addressData.residentialAddress };

          const payload = {
            ...userData,
            ...address,
            mailingAddress: addressData.mailingAddress,
          };

          await this.updateUserProfile({
            ...payload, ...options,
          });

          this.isLoading = false;
          await this.loadUserDetail();
        } catch (err) {
          this.isLoading = false;
          this.userProfile.socialSecurityNum = this.previousSSN;
        }
      },
      showUserModalsError(listUserErrors) {
        this.setErrorsModalInfo(listUserErrors);
        this.showErrorsModal();
      },
      submitDifferentMailingAddress() {
        this.userProfile.mailingAddress.streetAddress1 = '';
        this.userProfile.mailingAddress.streetAddress2 = '';
        this.userProfile.mailingAddress.zipCode = '';
        this.userProfile.mailingAddress.city = '';
        this.userProfile.mailingAddress.state = '';
      },
      disableSubmitButton() {
        return !this.userProfile.firstName || !this.userProfile.firstName.trim()
        || !this.userProfile.lastName.trim()
        || !this.userProfile.primaryPhoneNum || !this.userProfile.email.trim() ||
            (!this.userProfile.residentialAddress.streetAddress1.trim() ||
              !this.userProfile.residentialAddress.zipCode.trim() ||
              !this.userProfile.residentialAddress.city.trim() ||
              !this.userProfile.residentialAddress.state ||
              (this.isResidentDefaultAddress &&
                (!this.userProfile.mailingAddress.streetAddress1.trim() ||
                  !this.userProfile.mailingAddress.zipCode.trim() ||
                  !this.userProfile.mailingAddress.city.trim() ||
                  !this.userProfile.mailingAddress.state
                )
              )
            )
            || this.isLoading;
      },
      showConfirmationModal() {
        this.isLoading = false;
        this.showQuestionModal({
          title: Constants.userDetail.modalTitle,
          question: Constants.userDetail.ModalUserConfirmation,
          method: async () => {
            await this.methodToExecuteInQuestionModal();
          },
          yesButtonText: Constants.userDetail.modalYesButtonText,
          hideCancelButton: false,
        });
      },
      updateActiveAccount() {
        const account = this.userProfile.accounts.find(ac => ac.id === this.activeAccountId);
        this.setActiveAccountId(account);
      },
      async methodToExecuteInQuestionModal() {
        this.hideQuestionModal();
        this.isLoading = true;
        const { userProfile } = this;
        userProfile.updateCount += 1;
        userProfile.isResidentDefaultAddress = this.isResidentDefaultAddress;

        delete userProfile.dwollaCustomerId;
        delete userProfile.accounts;
        delete userProfile.roles;
        delete userProfile.accountType;
        delete userProfile.organizationName;
        delete userProfile.CRDnumber;
        delete userProfile.userId;
        delete userProfile.socialSecurityNum;
        delete userProfile.dateOfBirth;
        return this.save(userProfile);
      },
    },
    components: {
      datePicker,
      errors,
      spinner,
      information,
      accountCreation,
      RestrictedTwoInputs,
      question: Question,
      'address-suggestion': addressSuggestion,
      'addresses-form': addresses,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .backgroundImage {
    background-image: url(../assets/img/bg.jpg);
  }
  .message-feedback {
    background-color: #dbe9db;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 66%;
  }
  .birth-field-bottom {
    margin-bottom: 5px;
  }
  .button-submit {
    background-color: #127285;
  }
  .date-pick-style {
    width: 90%;
  }
  .content-wrapper {
    border-top: none;
    word-wrap: break-word;
  }
  .content-wrapper-banner {
    border-top: none;
    padding-bottom: 0px;
  }
  .content-wrapper-container {
    border-top: none;
    padding-top: 0px;
  }
  .warning-heading {
    background-color: #f9f2ce !important;
    padding: 10px;
    margin: 0 auto 20px;
    font-size: 14px;
    font-weight: 500;
  }
  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }
  .icon-back {
    position: relative;
  }
  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }
  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }
  .left-margin {
    margin-left: 4%;
  }
  .right-margin {
    margin-right: 4%;
  }
  .top-margin {
    margin-top: 2%;
  }
  .bottom-margin {
    margin-bottom: 2%;
  }
  .space {
    margin-top: 4%;
  }
  .content-heading {
    font-weight: normal;
  }
  .upload-container {
    height: 80px;
    padding-top: 10px;
  }
  .panel-title {
    font-size: 20px;
  }
  .panel-subtitle {
    font-size: 16px;
  }
  .panel-default {
    padding: 30px 40px;
  }
  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }
  label {
    color: #888;
    font-size: 14px;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }
  select:required:invalid {
    color: lightgray;
  }
  option[value=""][disabled] {
    display: none;
  }
  option {
    color: black;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: lightgray;
    opacity: 1;
    /* Firefox */
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: lightgray;
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: lightgray;
  }
  .disabled-state {
    font-color: #0000;
    color: #ccc;
  }
  .text-red {
    color: #a94442;
  }
  .btn-new {
    background-color: #127285;
  }
  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }
  .radio-item input[type='radio'] {
    display: none;
  }
  .radio-item label {
    color: #666;
    font-weight: normal;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-repay label:before {
    left: 190px;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }
  .radio-item-repay input[type=radio]:checked+label:after {
    left: 201px;
  }
  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 0px #ddd;
  }
  tbody{
    height:200px;
      overflow-y:auto;
      width: 100%;
  }
  thead{
      display:block;
    width: 100%;
  }
  tbody{
    display:block;
  }
  tr{
    width: 100%;
    display: block;
  }
  td{
    display:block;
    width: 14%;
  }
  th{
    display:block;
    width: 14%;
  }
  td{
    float: left;
    width: 14%;
  }
  thead{
    float: left;
  }
  tr{
    float: left;
  }
  th{
    float: left;
  }
  .smallWidth{
    width: 10%
  }
  .bigWidth{
    width: 16%
  }

  .information-title {
   color: #63adba;
   margin-bottom: 5px;
   font-size: 14px;
  }

  .thumb45 {
    width: 40px !important;
    height: 40px !important;
    margin-top: 6px;
    margin-left: 33px;
  }

  .media-heading {
    font-weight: 400;
    font-size: 24px;
  }

  .panel, .panel-body {
    border-radius: 4px;
  }

  .bg-cover {
    background-color: #00798e;
    padding: 10px !important;
    box-sizing: border-box;
  }

  .title-panel {
    box-shadow: 0 -2px 0 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #004f5c;
  }

</style>



// WEBPACK FOOTER //
// EditUserProfileByAdvisor.vue?1c565420